const sharedSettings = {
  name: { editable: true, type: 'input', rules: [{ required: true }] },

  is_default: { editable: true, type: 'switch', rules: [{ required: false }] },
  is_auto_populate: { editable: true, type: 'switch', rules: [{ required: false }] },
  is_visible: { editable: true, type: 'switch', rules: [{ required: false }] },

  created_at: { hidden: true },
  updated_at: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  name: "",
  is_default: false,
  is_auto_populate: false,
  is_visible: true
};
